import api, { Base, Tags } from 'ev-api/api';

import {
  CdxModule,
  CdxModulesListData,
  CdxModulesListResponse,
  CdxProxyEnvelope,
  GetModuleParams,
  ListModulesByGroupParams,
  ListModulesParams,
} from './module-types';

export const modulesByGroupQuery = ({
  moduleGroupHandle,
  page,
}: ListModulesByGroupParams) => ({
  url: `${Base.V4}/cdx_proxy/config/modules`,
  params: {
    'filter[module_group_handle]': moduleGroupHandle,
    ...(page ? { page } : {}),
  },
});

const cdxModulesApi = api.injectEndpoints({
  endpoints: builder => ({
    listModules: builder.query<CdxModule[], ListModulesParams | void>({
      query: params => ({
        url: `${Base.V4}/cdx_proxy/config/modules`,
        params: {
          'filter[auto_render]': true,
          ...(params && params.page ? { page: params.page } : {}),
        },
      }),
      transformResponse: (response: CdxModulesListResponse) =>
        response.data.modules,
      providesTags: [Tags.CdxModules],
    }),
    listModulesByGroup: builder.query<
      CdxModulesListData,
      ListModulesByGroupParams
    >({
      query: modulesByGroupQuery,
      // Keeps the envelope metadata, unlike listModules, so callers can see
      // whether the proxy paginated the group.
      transformResponse: (response: CdxModulesListResponse) => response.data,
      providesTags: [Tags.CdxModules],
    }),
    getModule: builder.query<CdxModule, GetModuleParams>({
      query: ({ handle }) => ({
        url: `${Base.V4}/cdx_proxy/config/modules/${handle}`,
      }),
      transformResponse: (response: CdxProxyEnvelope<CdxModule>) =>
        response.data,
      providesTags: [Tags.CdxModules],
    }),
  }),
});

export const {
  useListModulesQuery,
  useListModulesByGroupQuery,
  useGetModuleQuery,
} = cdxModulesApi;
